import React, { Component } from "react"
import { Container, Row, Col, Spinner, Button, Form } from "react-bootstrap"
import { Typeahead } from "react-bootstrap-typeahead"
import { FaAngleDown, FaPencilAlt, FaTimes } from "react-icons/fa"
import MaskedInput from "react-maskedinput"
import { Subscription } from "rxjs"
import GeneralInformation, { PersonDemographicRecord, PersonDemographicObject, RegMode, Supervisor } from "../../../api/OrderResults/OrderResultModel/GeneralInformation"
import { GeneralInformationGet, GetPersonDemographicsDetail } from "../../../api/OrderResults/GeneralInformationGet"
import { toast } from "react-toastify"
import { AppState } from "../../../AppState"
import { connect } from "react-redux"
import FormatDate from "../../../formatters/FormatDate"
import FormatPhone from "../../../formatters/FormatPhone"
import FormatSSN from "../../../formatters/FormatSSN"
import { ValidZipCode } from "../../../formatters/FormatZipCode"
import { BuildUserAccess } from "../../../authentication/BuildUserAccess"
import UserAccessSettings from "../../../authentication/UserAccessSettings";
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import { EmailRegexp, PhoneRegexp } from "../../../config/Constants"
import { BirthdayInput } from "../../FormattedInputs/BirthdayInput"
import PhoneNumberMaskedInput from "../../FormattedInputs/PhoneNumberMaskedInput"
import ActionButton from "../../ActionButton"
import AutoFilterCompaniesGet from "../../../api/Companies/AutoFilterCompaniesGet"
import AutoFilterCompany from "../../../api/Companies/CompanyModel/AutoFilterCompany"
import AutoFilterLocation from "../../../api/Location/LocationModel/AutoFilterLocation"
import AutoFilterLocationsGet from "../../../api/Location/AutoFilterLocationsGet"
import State from "../../../api/OrderRequests/OrderRequestsModel/State"
import RegulatoryMode from "../../../api/LabService/LabServiceModel/RegulatoryMode"
import LabServiceRegulatoryModesGetObservable from "../../../api/LabService/LabServiceRegulatoryModesGet"
import StateSelect from "../../FormattedInputs/StateSelect"
import { StateObservable } from "../../../api/OrderRequests/OrderRequestsConstraintGet"
import { GeneralInformationSave, UpdatePersonDemographic, SaveRegulatoryMode } from "../../../api/OrderResults/GeneralInformationGet"
import FormatError from "../../../formatters/FormatError"
import KeyValue from "../../../api/Administration/Model/KeyValue"
import EmployeeRegModeModal from "./EmployeeRegModeModal"
import { isCompanyAdmin, isPortalAdmin } from "../../../authentication/isAdminRole"
import { GetSelectedAssignedClinic } from "../../../authentication/SelectedCompany/CompanySelectionDrivenSelectors"
import SupervisorsModal from "./SupervisorsModal"

// TODO: "CreateRegModeString" type was copied from Workforce 1.0
type CreateRegModeString = {
  EmpCat: string
  EmployeeCategoryID: number
  PersonRegModeEmpCatID: number
  Primary: boolean
  RegMode: string
  RegulatoryModeID: number
}

function regulatoryModeValue(results: CreateRegModeString[]): string {
  if (results.length > 0) {
    let primary: CreateRegModeString | undefined = results.find(item => item.Primary)
    let result: string = primary ? primary.RegMode : ""
    let otherRegModes: string = results.filter(item => !item.Primary).map(item => item.RegMode).join(", ")
    if (otherRegModes !== "") {
      result = `${result} (${otherRegModes})`
    }
    return result
  } else {
    return "N/P"
  }
}

const HeaderRow = (props: { title: string }) =>
  <Row>
    <Col><h5 className="pt-3 pb-2">{props.title}</h5></Col>
  </Row>


function HeaderRowWithSwitchMode(props: { title: string, showEditButton: boolean, editing: boolean, handleToggleEditMode: any }) {
  return <Row>
    <Col><h5 className="pt-3 pb-2">{props.title}</h5></Col>
    {props.showEditButton && <Col xs={1}>
      <h5>
        <Button variant="icon-link" size="sm" className="float-right ml-1 btn-icon-primary" onClick={props.handleToggleEditMode} >
          {!props.editing && <FaPencilAlt />}
          {props.editing && <FaTimes />}
        </Button>
      </h5>
    </Col>
    }
  </Row>
}

const InfoRow = (props: { title: string, value: string | null, className?: string }) => <Row className="py-1">
  <Col xs={6} md={4}><span className="caption">{props.title}</span></Col>
  <Col xs={6} md={8}><span className={props.className}>{props.value}</span></Col>
</Row>

const UserRow = (props: { title: string, value: string | null, empty: string }) => {
  const caption = props.title.toString().trim()
  return (
    <Row className="py-1">
      <Col xs={6} md={4}><span className="caption text-uppercase">{caption.length > 0 && caption !== "N/A" ? caption : props.empty}</span></Col>
      <Col xs={6} md={8}><span>{props.value}</span></Col>
    </Row>
  )
}
const InfoRowWithInput = (props: { title: string, value: string | null, className?: string, input: React.ReactNode }) => <Row className={`py-1 ${props.className || ""}`}>
  <Col xs={6} md={4}><span className="caption">{props.title}</span></Col>
  <Col xs={6} md={8}>
    {props.input}
  </Col>
</Row>

const UserRowWithInput = (props: { title: string, value: string | null, empty: string }) => {
  const caption = props.title.toString().trim()
  return (
    <Row className="py-1">
      <Col xs={6} md={4}><span className="caption text-uppercase">{caption.length > 0 && caption !== "N/A" ? caption : props.empty}</span></Col>
      <Col xs={6} md={8}><span>{props.value}</span></Col>
    </Row>
  )
}

interface GeneralInfoProps {
  PersonID: number
  isGov?: boolean
  onUpdate?: () => void
}

interface GeneralInfoAuthProps {
  userPermissions?: UserAccessSettings
  isPortalAdmin: boolean
  isCompanyAdmin: boolean
  companyID: number
}

interface GeneralInfoState {
  data?: GeneralInformation,
  editData?: GeneralInformation,
  editing: boolean,
  saving: boolean
  isGeneralInfoLoading: boolean,
  isPersonDemographicsDetailLoading: boolean,
  isRegulatoryModesLoading: boolean
  isStatesLoading: boolean
  isLocationsLoading: boolean
  isCompaniesLoading: boolean
  isSupervisorsLoading: boolean
  regulatoryModes?: RegulatoryMode[]
  selectedRegulatoryMode?: RegulatoryMode
  selectedCompany?: AutoFilterCompany
  selectedLocation?: AutoFilterLocation
  companies: AutoFilterCompany[]
  locations: AutoFilterLocation[]
  states: State[]
  isSupervisorsLoaded: boolean
  isStatesLoaded: boolean
  isRegulatoryModesLoaded: boolean
  isCompaniesLoaded: boolean
  personDemographicRecords: PersonDemographicObject[]
  userDefinedRecords: []
  implementationAliasRecords: []
  personDemographicObject?: PersonDemographicObject
  showEmployeeRegModes: boolean
  showSupervisors: boolean
}
interface Gender {
  Name: string
  Code: string
}

const genders: Gender[] = [{ Name: "Male", Code: "M" }, { Name: "Female", Code: "F" }]

export class GeneralInfo extends Component<GeneralInfoProps & GeneralInfoAuthProps, GeneralInfoState> {
  state: GeneralInfoState = {
    data: undefined,
    editing: false,
    saving: false,
    isGeneralInfoLoading: false,
    isPersonDemographicsDetailLoading: false,
    isRegulatoryModesLoading: false,
    isStatesLoading: false,
    isLocationsLoading: false,
    isCompaniesLoading: false,
    isSupervisorsLoading: false,
    regulatoryModes: undefined,
    selectedRegulatoryMode: undefined,
    companies: [],
    locations: [],
    states: [],
    isSupervisorsLoaded: false,
    isStatesLoaded: false,
    isRegulatoryModesLoaded: false,
    isCompaniesLoaded: false,
    personDemographicRecords: [],
    userDefinedRecords: [],
    implementationAliasRecords: [],
    personDemographicObject: undefined,
    showEmployeeRegModes: false,
    showSupervisors: false
  }
  generalInfoSubscription?: Subscription
  personDemographicsDetailSubscription?: Subscription
  regulatoryModesSubscription?: Subscription
  statesSubscription?: Subscription
  supervisorsSubscription?: Subscription
  companiesSubscription?: Subscription
  locationsSubscription?: Subscription
  generalInfoSaveSubscription?: Subscription
  personDemographicsSaveSubscription?: Subscription
  saveRegulatoryModeSubscription?: Subscription

  companyTypeahead = React.createRef<Typeahead<AutoFilterCompany>>()
  locationTypeahead = React.createRef<Typeahead<AutoFilterLocation>>()
  genderTypeahead = React.createRef<Typeahead<Gender>>()
  hiredate = React.createRef<DatePicker>()
  birthdate = React.createRef<DatePicker>()
  terminationDate = React.createRef<DatePicker>()
  occupationTypeahead = React.createRef<Typeahead<KeyValue>>()
  user1Typeahead = React.createRef<Typeahead<KeyValue>>()
  user2Typeahead = React.createRef<Typeahead<KeyValue>>()
  user3Typeahead = React.createRef<Typeahead<KeyValue>>()
  user4Typeahead = React.createRef<Typeahead<KeyValue>>()
  user5Typeahead = React.createRef<Typeahead<KeyValue>>()
  user6Typeahead = React.createRef<Typeahead<KeyValue>>()
  user7Typeahead = React.createRef<Typeahead<KeyValue>>()
  user8Typeahead = React.createRef<Typeahead<KeyValue>>()

  componentDidMount() {
    this.loadGeneralInfo(this.props.PersonID)
    this.loadPersonDemographicsDetail(this.props.PersonID)
  }

  componentWillUnmount() {
    this.generalInfoSubscription && this.generalInfoSubscription.unsubscribe()
    this.personDemographicsDetailSubscription && this.personDemographicsDetailSubscription.unsubscribe()
    this.regulatoryModesSubscription && this.regulatoryModesSubscription.unsubscribe()
    this.statesSubscription && this.statesSubscription?.unsubscribe()
    this.supervisorsSubscription && this.supervisorsSubscription?.unsubscribe()
    this.companiesSubscription && this.companiesSubscription?.unsubscribe()
    this.locationsSubscription && this.locationsSubscription?.unsubscribe()
    this.generalInfoSaveSubscription && this.generalInfoSaveSubscription?.unsubscribe()
    this.personDemographicsSaveSubscription && this.personDemographicsSaveSubscription?.unsubscribe()
    this.saveRegulatoryModeSubscription && this.saveRegulatoryModeSubscription?.unsubscribe()
  }

  componentDidUpdate(prevProps: GeneralInfoProps) {
    if (this.props.PersonID !== prevProps.PersonID) {
      this.loadGeneralInfo(this.props.PersonID)
    }
  }

  loadGeneralInfo(PersonID: number) {
    this.setState({ isGeneralInfoLoading: true })
    this.generalInfoSubscription && this.generalInfoSubscription.unsubscribe()
    this.generalInfoSubscription = GeneralInformationGet(PersonID).subscribe(
      (data: GeneralInformation) => this.setState({ data: data }),
      (error) => {
        this.setState({ isGeneralInfoLoading: false })
        toast.error(FormatError(error))
      },
      () => this.setState({ isGeneralInfoLoading: false })
    )
  }

  loadPersonDemographicsDetail(PersonID: number) {
    this.setState({ isPersonDemographicsDetailLoading: true })
    this.personDemographicsDetailSubscription && this.personDemographicsDetailSubscription.unsubscribe()
    this.personDemographicsDetailSubscription = GetPersonDemographicsDetail(PersonID).subscribe(
      (data: PersonDemographicRecord) => this.setState({
        personDemographicRecords: data.PersonDemographicRecords,
        userDefinedRecords: data.UserDefinedRecords,
        implementationAliasRecords: data.ImplementationAliasRecords,
        personDemographicObject: (data.PersonDemographicRecords.length > 0) ? data.PersonDemographicRecords[0] : undefined
      }),
      (error) => {
        this.setState({ isPersonDemographicsDetailLoading: false })
        toast.error(FormatError(error))
      },
      () => this.setState({ isPersonDemographicsDetailLoading: false })
    )
  }

  handleToggleEditMode = () => {
    if (this.state.editing) {
      if (this.props.PersonID > 0) {
        this.loadGeneralInfo(this.props.PersonID)
        this.loadPersonDemographicsDetail(this.props.PersonID)
      }
      this.setState({ editing: false, selectedCompany: undefined, selectedLocation: undefined })
    }
    else {
      this.setState({ editing: true })
      this.loadStates()
      this.loadRegulatoryModes()
      this.loadAllCompanies()
    }
  }

  loadStates = () => {
    if (this.state.isStatesLoaded) {
      return
    }
    this.statesSubscription && this.statesSubscription?.unsubscribe()
    this.statesSubscription =
      StateObservable().subscribe(
        (results: State[]) => this.setState({ states: results, isStatesLoading: false, isStatesLoaded: true }),
        () => { this.setState({ isStatesLoading: false }) }
      )


  }
  loadRegulatoryModes = () => {

    if (this.state.isRegulatoryModesLoaded) {
      return
    }
    this.setState({ isRegulatoryModesLoading: true })
    this.regulatoryModesSubscription && this.regulatoryModesSubscription.unsubscribe()
    this.regulatoryModesSubscription = LabServiceRegulatoryModesGetObservable(true).subscribe(
      (data: RegulatoryMode[]) => this.setState({
        regulatoryModes: data,
        isRegulatoryModesLoading: false,
        isRegulatoryModesLoaded: true
      }),
      () => this.setState({ isRegulatoryModesLoading: false })
    )
  }

  loadAllCompanies = () => {
    if (this.state.isCompaniesLoaded) {
      this.initialCompanyChange(this.state.companies)
      return
    }
    this.setState({ isCompaniesLoading: true })

    AutoFilterCompaniesGet("").subscribe(
      data => {
        this.setState({ companies: data, isCompaniesLoading: false, isCompaniesLoaded: true })
        this.initialCompanyChange(data)
      },
      () => this.setState({ isCompaniesLoading: false })
    )
  }

  initialCompanyChange = (companies: AutoFilterCompany[]) => {
    if (companies.length > 0) {
      const currentCompany = companies.find(comp => comp.AccountID === this.state.data?.CompanyID)
      this.setState({ selectedCompany: currentCompany })
      if (!!currentCompany) this.loadAllLocations(currentCompany, true)
    } else {
      this.setState({
        locations: [],
        selectedCompany: undefined,
        selectedLocation: undefined
      })
    }
  }

  handleLocationChange = (locations: AutoFilterLocation[]) => this.setState({ selectedLocation: locations[0] })

  handleCompanyChange = (companies: AutoFilterCompany[]) => {
    const selectedCompany = companies[0]
    this.setState({ selectedCompany: companies[0], locations: [], selectedLocation: undefined })
    if (!!selectedCompany) this.loadAllLocations(selectedCompany, false)
  }

  loadAllLocations = (company: AutoFilterCompany, initialLoad: boolean) => {
    this.setState({ isLocationsLoading: true })
    this.locationsSubscription && this.locationsSubscription?.unsubscribe()
    this.locationsSubscription =
      AutoFilterLocationsGet(company.AccountID, "", "").subscribe(
        data => {
          const currentLocation = data.find(loc => loc.AccountID === this.state.data?.AccountID)
          this.setState({ locations: data, selectedLocation: initialLoad ? currentLocation : undefined, isLocationsLoading: false })
        },
        () => this.setState({ isLocationsLoading: false })
      )
  }

  handleSubmit = () => {
    if (!this.state.editing) {
      return false
    }
    const data = this.state.data
    if (!data) {
      return
    }
    this.setState({ editing: false, saving: true })
    data.RegModeEmpCat = {
      EmpCat: "",
      EmployeeCategoryID: 0,
      PersonRegModeEmpCatID: 0,
      Primary: false,
      RegMode: "",
      RegulatoryModeID: 0
    }
    data.CompanyID = this.state.selectedCompany?.AccountID || 0
    data.LocationID = this.state.selectedLocation?.AccountID || 0
    this.generalInfoSaveSubscription && this.generalInfoSaveSubscription?.unsubscribe()
    this.personDemographicsSaveSubscription && this.personDemographicsSaveSubscription?.unsubscribe()
    this.saveRegulatoryModeSubscription && this.saveRegulatoryModeSubscription?.unsubscribe()
    this.generalInfoSaveSubscription = GeneralInformationSave(data).subscribe(
      ((result) => {
        const personID = Number(result)
        if (personID > 0) {
          const pdo = this.state.personDemographicObject
          if (pdo) {
            pdo.Occupation = pdo.OccupationCode
            pdo.User1 = pdo.User1Code
            pdo.User2 = pdo.User2Code
            pdo.User3 = pdo.User3Code
            pdo.User4 = pdo.User4Code
            pdo.User5 = pdo.User5Code
            pdo.User6 = pdo.User6Code
            pdo.User7 = pdo.User7Code
            pdo.User8 = pdo.User8Code
            pdo.CompanyID = this.state.selectedCompany?.AccountID || 0
            pdo.LocationID = this.state.selectedLocation?.AccountID || 0

            this.personDemographicsSaveSubscription = UpdatePersonDemographic(pdo).subscribe(
              ((result) => {
                toast.success(result)
              }),
              (error) => {
                toast.error(FormatError(error))
              }
            )
            this.saveRegulatoryModeSubscription = SaveRegulatoryMode(personID, data.RegModCatList).subscribe(
              ((result) => {
                //toast.success(result)
              }),
              (error) => {
                toast.error(FormatError(error))
              }
            )
          }
          this.setState({ saving: false })
          toast.success("Updated personnel data successfully.")
          this.loadGeneralInfo(personID)
          this.loadPersonDemographicsDetail(personID)
          this.props.onUpdate && this.props.onUpdate()
        } else {
          toast.error(result)
        }
      }),
      (error) => {
        this.setState({ saving: false })
        toast.error(FormatError(error))
      }
    )
    return false
  }
  ssnRequired = () => this.state.data?.CompanyPrimaryID === "SSN"
  employerIDRequired = () => this.state.data?.CompanyPrimaryID === "EmployerID"
  driverIDRequired = () => this.state.data?.CompanyPrimaryID === "DriverID"
  alternateIDRequired = () => this.state.data?.CompanyPrimaryID === "AlternateID"

  checkIsPhoneValid = (value: string) => value.length === 0 || PhoneRegexp.test(value) || value.toLowerCase() === "n/p"
  checkIsNotEmpty = (value: string, required: boolean) => !required || value.trim().length > 0
  checkIsSSNValid = (value: string, required: boolean) => (!required && value.length === 0) || value.replace(/\D/g, "").length === 9
  checkIsEmailValid = (value: string) => {
    if (value.length === 0) {
      return true
    }
    return EmailRegexp.test(value)
  }
  createFirstNameRow = () => {
    const data: GeneralInformation = this.state.data!
    const editing = this.state.editing
    if (!editing) {
      return <InfoRow title="First Name" value={data.FirstName} className="text-uppercase" />
    }
    const input = <Form.Control type="text" isInvalid={!this.isFirstNameValid()} maxLength={20} value={data.FirstName} onChange={(e: React.ChangeEvent<HTMLInputElement>) => this.handleFirstNameChange(e)} />
    const result = <InfoRowWithInput title="First Name" value={data.FirstName} className="text-uppercase" input={input} />
    return result

  }

  handleFirstNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    this.state.data && this.setState(prevState => {
      return { data: prevState.data ? { ...prevState.data, FirstName: value } : prevState.data }
    })
  }

  isFirstNameValid = () => {
    return true
  }

  createLastNameRow = () => {
    const data: GeneralInformation = this.state.data!
    const editing = this.state.editing
    if (!editing) {
      return <InfoRow title="Last Name" value={data.LastName} className="text-uppercase" />
    }
    const input = <Form.Control type="text" isInvalid={!this.isLastNameValid()} maxLength={20} value={data.LastName} onChange={(e: React.ChangeEvent<HTMLInputElement>) => this.handleLastNameChange(e)} />
    const result = <InfoRowWithInput title="Last Name" value={data.LastName} className="text-uppercase" input={input} />
    return result

  }
  handleLastNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    this.state.data && this.setState(prevState => {
      return { data: prevState.data ? { ...prevState.data, LastName: value } : prevState.data }
    })
  }
  isLastNameValid = () => {
    return true

  }
  createEmployerIdRow = () => {
    const data: GeneralInformation = this.state.data!
    const editing = this.state.editing
    if (!editing) {
      return <InfoRow title="EMPLOYER ID" value={data.Employer} className="text-uppercase" />
    }
    const input = <Form.Control type="text" isInvalid={!this.isEmployerIdValid()} value={data.Employer} onChange={(e: React.ChangeEvent<HTMLInputElement>) => this.handleEmployerIdChange(e)} />
    const result = <InfoRowWithInput title="EMPLOYER ID" value={data.Employer} className="text-uppercase" input={input} />
    return result

  }
  handleEmployerIdChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    this.state.data && this.setState(prevState => {
      return { data: prevState.data ? { ...prevState.data, Employer: value } : prevState.data }
    })
  }
  isEmployerIdValid = () => {
    const data: GeneralInformation = this.state.data!
    const value = data.Employer ? data.Employer.trim() : ""
    if (this.employerIDRequired()) {
      return value.length > 0
    }
    return true
  }

  createAlternateIdRow = () => {
    const data: GeneralInformation = this.state.data!
    const editing = this.state.editing
    if (!editing) {
      return <InfoRow title="ALTERNATE ID" value={data.Alternate} className="text-uppercase" />
    }
    const input = <Form.Control type="text" isInvalid={!this.isAlternateIdValid()} value={data.Alternate} onChange={(e: React.ChangeEvent<HTMLInputElement>) => this.handleAlternateIdChange(e)} />
    const result = <InfoRowWithInput title="ALTERNATE ID" value={data.Alternate} className="text-uppercase" input={input} />
    return result

  }
  handleAlternateIdChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    this.state.data && this.setState(prevState => {
      return { data: prevState.data ? { ...prevState.data, Alternate: value } : prevState.data }
    })
  }
  isAlternateIdValid = () => {
    const data: GeneralInformation = this.state.data!
    const value = data.Alternate ? data.Alternate.trim() : ""
    if (this.alternateIDRequired()) {
      return value.length > 0
    }
    return true
  }



  createSSNRow = () => {
    const data: GeneralInformation = this.state.data!
    const editing = this.state.editing
    if (!editing) {
      return <InfoRow title="SSN" value={FormatSSN(data.SSN || "")} />
    }
    const input = <Form.Control type="text" as={MaskedInput} mask="111-11-1111" isInvalid={!this.isSSNValid()} value={data.SSN} onChange={(e: React.ChangeEvent<HTMLInputElement>) => this.handleSSNChange(e)} />
    const result = <InfoRowWithInput title="SSN" value={data.Alternate} className="text-uppercase" input={input} />
    return result
  }

  handleSSNChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value || "";
    this.state.data && this.setState(prevState => {
      return { data: prevState.data ? { ...prevState.data, SSN: value.replace(/\D/g, "") } : prevState.data }
    })
  }
  isSSNValid = () => {
    const data: GeneralInformation = this.state.data!
    const value = data.SSN ? data.SSN.trim() : ""
    const required = this.ssnRequired()
    return this.checkIsSSNValid(value, required)
  }




  createDriverIdRow = () => {
    const data: GeneralInformation = this.state.data!
    const editing = this.state.editing
    if (!editing) {
      return <InfoRow title="DRIVER ID" value={data.Driver} className="text-uppercase" />
    }
    const input = <Form.Control type="text" isInvalid={!this.isDriverIdValid()} value={data.Driver} onChange={(e: React.ChangeEvent<HTMLInputElement>) => this.handleDriverIdChange(e)} />
    const result = <InfoRowWithInput title="DRIVER ID" value={data.Driver} className="text-uppercase" input={input} />
    return result

  }
  handleDriverIdChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    this.state.data && this.setState(prevState => {
      return { data: prevState.data ? { ...prevState.data, Driver: value } : prevState.data }
    })
  }
  isDriverIdValid = () => {
    const data: GeneralInformation = this.state.data!
    const value = data.Driver ? data.Driver.trim() : ""
    if (this.driverIDRequired()) {
      return value.length > 0
    }
    return true
  }

  createOccupationRow = () => {
    const data: GeneralInformation = this.state.data!
    const demographicLabels = data.ImplementationAlias
    const demographicInfo = data.PersonDemographicObj
    const editing = this.state.editing
    let occupationTitle: string = "OCCUPATION"
    if (data.ImplementationAlias?.Occupation) {
      occupationTitle = data.ImplementationAlias.Occupation.toUpperCase()
      if (occupationTitle === "N/A") {
        occupationTitle = "OCCUPATION"
      }
    }
    
    const occupation = data.Occupation.length > 0 ? `${data.Occupation}` : "" 
    
    if (!editing) {
      return <InfoRow title={occupationTitle} value={occupation} className="text-uppercase" />
    }
    const values = this.state.userDefinedRecords.filter(item => item['Type'] === "OC")
    if (values.length === 0) {
      return <InfoRow title={occupationTitle} value={occupation} className="text-uppercase" />
    }
    const options: KeyValue[] = values.map(item => {
      let rObj: KeyValue = {
        Key: item['Code'],
        Value: item['Description']
      }
      return rObj
    })

    const input = (
      <Form.Control
        type="text"
        value={data.OccupationCode}
        maxLength={30}
        onChange={(e) => this.handleOccupationChange({ Key: e.target.value, Value: e.target.value })}
      />
    )
    const result = <InfoRowWithInput title={occupationTitle} value={data.Occupation} className="text-uppercase" input={input} />
    return result
  }

  handleOccupationChange = (value: KeyValue) => {
    const { data, personDemographicObject } = this.state
    if (data && personDemographicObject) {
      this.setState({
        data: { ...data, PersonDemographicObj: { ...data.PersonDemographicObj, Occupation: value.Value }, OccupationCode: value.Key, Occupation: value.Key },
        personDemographicObject: { ...personDemographicObject, OccupationCode: value.Key, Occupation: value.Key }
      });
    }
  }

  isOccupationValid = () => {
    return true

  }

  createRegulatoryModeRow = () => {
    const data: GeneralInformation = this.state.data!
    const editing = this.state.editing
    if (!editing) {
      return <InfoRow title="REGULATORY MODE" value={regulatoryModeValue(data.RegModCatList)} className="primary" />
    }
    const input = <Button variant="underline-link" className="px-0 mx-0" onClick={() => this.handleRegulatoryModeClick()}>{regulatoryModeValue(data.RegModCatList)} </Button>
    const result = <InfoRowWithInput title="REGULATORY MODE" value={regulatoryModeValue(data.RegModCatList)} className="text-uppercase" input={input} />
    return result
  }

  isRegulatoryModeValid = () => {
    return true

  }

  handleRegulatoryModeClick = () => {
    this.setState({ showEmployeeRegModes: true })
  }

  handleRegulatoryModeSave = (items: RegMode[]) => {
    const regulatoryModes = items || []
    this.state.data && this.setState(prevState => {
      return { data: prevState.data ? { ...prevState.data, RegModCatList: regulatoryModes } : prevState.data, showEmployeeRegModes: false }
    })
    //this.setState({ showEmployeeRegModes: false })
  }

  handleSupervisorsSave = (items: Supervisor[]) => {
    const supervisors = items || []
    this.state.data && this.setState(prevState => {
      return { data: prevState.data ? { ...prevState.data, Supervisor1Data: items[0], Supervisor2Data: items[1] } : prevState.data, showSupervisors: false }
    })
  }

  handleRegulatoryModeClose = () => {
    this.setState({ showEmployeeRegModes: false })
  }

  handleSupervisorsClose = () => {
    this.setState({ showSupervisors: false })
  }

  createHireDateRow = () => {
    const data: GeneralInformation = this.state.data!
    const editing = this.state.editing

    if (!editing) {
      return <InfoRow title="HIRE DATE" value={FormatDate(data.HireDate || "")} />
    }

    const val = data.HireDate ? new Date(data.HireDate) : null
    const input = <DatePicker className="form-control"
      ref={this.hiredate}
      peekNextMonth
      showMonthDropdown
      showYearDropdown
      dropdownMode="select"
      maxDate={new Date()}
      selected={val}
      enableTabLoop={false}
      onKeyDown={(e) => { if (this.hiredate && this.hiredate.current && e.key === 'Tab') { this.hiredate.current.setOpen(false) } }}
      onChange={date => this.handleHireDateChange(date)}
      customInput={<BirthdayInput />} />


    const result = <InfoRowWithInput title="HIRE DATE" value={FormatDate(data.HireDate || "")} className="text-uppercase" input={input} />
    return result

  }
  handleHireDateChange = (date: any) => {
    this.state.data && this.setState(prevState => {
      return { data: prevState.data ? { ...prevState.data, HireDate: date } : prevState.data }
    })
  }
  isHireDateValid = () => {
    return true

  }

  createTerminationDateRow = () => {
    const data: GeneralInformation = this.state.data!
    const editing = this.state.editing

    if (!editing) {
      return <InfoRow title="TERMINATION DATE" value={FormatDate(data.TerminationDate) || "N/P"} />
    }

    const val = data.TerminationDate ? new Date(data.TerminationDate) : null
    const input = <DatePicker className="form-control"
      ref={this.terminationDate}
      peekNextMonth
      showMonthDropdown
      showYearDropdown
      dropdownMode="select"
      selected={val}
      enableTabLoop={false}
      onKeyDown={(e) => { if (this.terminationDate && this.terminationDate.current && e.key === 'Tab') { this.terminationDate.current.setOpen(false) } }}
      onChange={date => this.handleTerminationDateChange(date)}
      customInput={<BirthdayInput />} />


    const result = <InfoRowWithInput title="TERMINATION DATE" value={FormatDate(data.TerminationDate) || "N/P"} className="text-uppercase" input={input} />
    return result

  }
  handleTerminationDateChange = (date: any) => {
    this.state.data && this.setState(prevState => {
      return { data: prevState.data ? { ...prevState.data, TerminationDate: date } : prevState.data }
    })
  }
  isTerminationDateValid = () => {
    return true
  }

  createDateOfBirthRow = () => {
    const data: GeneralInformation = this.state.data!
    const editing = this.state.editing

    if (!editing) {
      return <InfoRow title="DATE OF BIRTH" value={FormatDate(data.DOB || "")} />
    }

    const val = data.DOB ? new Date(data.DOB) : null
    const input = <DatePicker className="form-control"
      ref={this.birthdate}
      peekNextMonth
      showMonthDropdown
      showYearDropdown
      dropdownMode="select"
      maxDate={new Date()}
      selected={val}
      enableTabLoop={false}
      onKeyDown={(e) => { if (this.birthdate && this.birthdate.current && e.key === 'Tab') { this.birthdate.current.setOpen(false) } }}
      onChange={date => this.handleDateOfBirthChange(date)}
      customInput={<BirthdayInput />} />


    const result = <InfoRowWithInput title="DATE OF BIRTH" value={FormatDate(data.DOB || "")} className="text-uppercase" input={input} />
    return result

  }
  handleDateOfBirthChange = (date: any) => {
    this.state.data && this.setState(prevState => {
      return { data: prevState.data ? { ...prevState.data, DOB: date } : prevState.data }
    })
  }
  isDateOfBirthValid = () => {
    return true

  }

  createAddress1Row = () => {
    const data: GeneralInformation = this.state.data!
    const editing = this.state.editing
    if (!editing) {
      return <InfoRow title="STREET ADDRESS" value={data.Address1} />
    }
    const input = <Form.Control type="text" isInvalid={!this.isAddress1Valid()} value={data.Address1} onChange={(e: React.ChangeEvent<HTMLInputElement>) => this.handleAddress1Change(e)} />
    const result = <InfoRowWithInput title="STREET ADDRESS" value={data.Address1} className="text-uppercase" input={input} />
    return result

  }

  handleAddress1Change = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    this.state.data && this.setState(prevState => {
      return { data: prevState.data ? { ...prevState.data, Address1: value } : prevState.data }
    })
  }

  isAddress1Valid = () => {
    return true
  }

  createCityRow = () => {
    const data: GeneralInformation = this.state.data!
    const editing = this.state.editing
    if (!editing) {
      return <InfoRow title="CITY" value={data.City} />
    }
    const input = <Form.Control type="text" isInvalid={!this.isCityValid()} value={data.City} onChange={(e: React.ChangeEvent<HTMLInputElement>) => this.handleCityChange(e)} />
    const result = <InfoRowWithInput title="CITY" value={data.City} className="text-uppercase" input={input} />
    return result

  }

  handleCityChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    this.state.data && this.setState(prevState => {
      return { data: prevState.data ? { ...prevState.data, City: value } : prevState.data }
    })
  }

  isCityValid = () => {
    return true
  }

  createInactiveRow = () => {
    const data: GeneralInformation = this.state.data!
    const editing = this.state.editing
    if (!editing) {
      return <InfoRow title="ACTIVE" value={!data.Inactive ? "Yes" : "No"} />
    }
    const input = <Form.Check checked={!data.Inactive} onChange={(e: React.ChangeEvent<HTMLInputElement>) => this.handleInactiveChange(e)} label="" id="personnel_inactive" />
    const result = <InfoRowWithInput title="ACTIVE" value={!data.Inactive ? "Yes" : "No"} className="text-uppercase" input={input} />
    return result

  }

  handleInactiveChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.checked;
    this.state.data && this.setState(prevState => {
      return { data: prevState.data ? { ...prevState.data, Inactive: !value } : prevState.data }
    })
  }

  isInactiveValid = () => {
    return true
  }

  createPreEmploymentTestOnFileRow = () => {
    const data: GeneralInformation = this.state.data!
    const editing = this.state.editing
    if (!editing) {
      return <InfoRow title="PRE-EMPLOYMENT TEST ON FILE" value={data.PreEmploymentTestOnFile ? "Yes" : "No"} />
    }
    const input = <Form.Check checked={data.PreEmploymentTestOnFile} onChange={(e: React.ChangeEvent<HTMLInputElement>) => this.handlePreEmploymentTestOnFileChange(e)} label="" id="pre_employment_test_on_file_row" className="mt-2" />
    const result = <InfoRowWithInput title="PRE-EMPLOYMENT TEST ON FILE" value={data.PreEmploymentTestOnFile ? "Yes" : "No"} className="text-uppercase" input={input} />
    return result
  }

  handlePreEmploymentTestOnFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.checked;
    this.state.data && this.setState(prevState => {
      return { data: prevState.data ? { ...prevState.data, PreEmploymentTestOnFile: value } : prevState.data }
    })
  }
  isPreEmploymentTestOnFileValid = () => {
    return true
  }

  createManagerRow = () => {
    const data: GeneralInformation = this.state.data!
    const editing = this.state.editing
    if (!editing) {
      return <InfoRow title="MANAGER" value={data.Manager ? "Yes" : "No"} />
    }
    const input = <Form.Check disabled={!this.props.isPortalAdmin} checked={data.Manager} onChange={(e: React.ChangeEvent<HTMLInputElement>) => this.handleManagerChange(e)} label="" id="manager_row" />
    const result = <InfoRowWithInput title="MANAGER" value={data.Manager ? "Yes" : "No"} className="text-uppercase" input={input} />
    return result
  }

  handleManagerChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.checked;
    this.state.data && this.setState(prevState => {
      return { data: prevState.data ? { ...prevState.data, Manager: value } : prevState.data }
    })
  }

  isManagerValid = () => {
    return true
  }

  supervisorInfo = (data: Supervisor) => {
    let row = ""
    if (data.FirstName.length > 0) row += `${data.FirstName} `
    if (data.LastName.length > 0) row += `${data.LastName} `
    if (data.ContactPhone.length > 0) row += `(${FormatPhone(data.ContactPhone)})`
    return row
  }

  createSupervisorRow = () => {
    const data: GeneralInformation = this.state.data!
    const editing = this.state.editing
    if (!editing) {
      return <>
        <InfoRow title="SUPERVISOR 1" value={this.supervisorInfo(data.Supervisor1Data)} />
        <InfoRow title="SUPERVISOR 2" value={this.supervisorInfo(data.Supervisor2Data)} />
      </>
    }
    const input = <Button variant="underline-link" className="px-0 mx-0" onClick={() => this.handleSupervisorsClick()}>CONFIGURE</Button>
    const result = <InfoRowWithInput title="SUPERVISORS" value={null} className="align-items-center" input={input} />
    return result
  }


  handleSupervisorsClick = () => {
    this.setState({ showSupervisors: true })
  }

  isSupervisor1Valid = () => true
  isSupervisor2Valid = () => true

  createGenderRow = () => {
    const data: GeneralInformation = this.state.data!
    const editing = this.state.editing
    if (!editing) {
      return <InfoRow title="GENDER" value={`${data.Gender === "F" ? "Female" : ""}${data.Gender === "M" ? "Male" : ""}`} />
    }

    const input = <div className="typeahead">
      <Typeahead id="gender"
        ref={this.genderTypeahead}
        labelKey="Name"
        filterBy={(option, props) => props.selected.length > 0 || option.Name.toLowerCase().indexOf(props.text.toLowerCase()) !== -1}
        onChange={selected => this.handleGenderChange(selected[0]?.Code || "")}
        options={genders}
        selected={data.Gender !== "" ? [genders.find((el) => el?.Code == data.Gender) || genders[0]] : []}
        placeholder="Select">
        <Button variant="toggle" onClick={() => { this.genderTypeahead && this.genderTypeahead.current && (this.genderTypeahead.current as any).toggleMenu() }}>
          <FaAngleDown />
        </Button>
      </Typeahead>
    </div>
    const result = <InfoRowWithInput title="GENDER" value={data.Gender} className="text-uppercase" input={input} />
    return result

  }

  handleGenderChange = (value: string) => {
    this.state.data && this.setState(prevState => {
      return { data: prevState.data ? { ...prevState.data, Gender: value } : prevState.data }
    })
  }
  isGenderValid = () => {
    return true
  }
  createStateRow = () => {

    const data: GeneralInformation = this.state.data!
    const states = this.state.states
    const statetID = data.StateID
    const statetCode = states.find(item => item.StateProvinceTerritoryID === statetID)?.Abbreviation || ""
    const editing = this.state.editing
    if (!editing) {
      return <InfoRow title="STATE" value={data.State} />
    }
    const input = <StateSelect states={states} dropButtonIfInvalid selectedCode={statetCode} onChange={(state) => this.handleStateChange(state)} />
    const result = <InfoRowWithInput title="STATE" value={data.State} className="text-uppercase" input={input} />
    return result
  }
  createCompanyRow = (name: string) => {
    if (this.state.editing && !!this.props.isPortalAdmin) {
      const input = <Typeahead id="company"
        key={Math.random().toString()}
        ref={this.companyTypeahead}
        labelKey="Name"
        filterBy={(option, props) => props.selected.length > 0 || option.Name.toLowerCase().indexOf(props.text.toLowerCase()) !== -1}
        isLoading={this.state.isCompaniesLoading}
        isInvalid={!this.isCompanyValid()}
        onChange={this.handleCompanyChange}
        options={this.state.companies}
        selected={this.state.selectedCompany ? [this.state.selectedCompany] : []}
        emptyLabel="No Companies Found"
        placeholder="Select">
        {!this.state.isCompaniesLoading &&
          <Button variant="toggle" onClick={() => { this.companyTypeahead?.current?.toggleMenu() }}>
            <FaAngleDown />
          </Button>}
      </Typeahead>
      const result = <InfoRowWithInput title="COMPANY" value={name} className="text-uppercase" input={input} />
      return result
    }
    else {
      return <InfoRow title="COMPANY" value={name} />
    }
   }

  createLocationRow = (name: string) => {
    if (this.state.editing && (!!this.props.isPortalAdmin || !!this.props.isCompanyAdmin)) {
      const input = <Typeahead id="location"
        key={Math.random().toString()}
        ref={this.locationTypeahead}
        labelKey="Name"
        filterBy={(option, props) => props.selected.length > 0 || option.Name.toLowerCase().indexOf(props.text.toLowerCase()) !== -1}
        isLoading={this.state.isLocationsLoading}
        onChange={this.handleLocationChange}
        options={this.state.locations}
        selected={this.state.selectedLocation ? [this.state.selectedLocation] : []}
        emptyLabel="No Locations Found"
        placeholder="Select">
        {!this.state.isLocationsLoading &&
          <Button variant="toggle" onClick={() => { this.locationTypeahead?.current?.toggleMenu() }}>
            <FaAngleDown />
          </Button>}
      </Typeahead>
      const result = <InfoRowWithInput title="LOCATION" value={name} className="text-uppercase" input={input} />
      return result
    }
    else {
      return <InfoRow title="LOCATION" value={name} />
    }
  }

  handleStateChange = (value: State) => {
    this.state.data && this.setState(prevState => {
      return { data: prevState.data ? { ...prevState.data, State: value.FullName, StateID: value.StateProvinceTerritoryID } : prevState.data }
    })
  }
  isStateValid = () => {
    const data: GeneralInformation = this.state.data!
    const value = data.StateID ? data.StateID : 0
    return value > 0
  }

  createZipRow = () => {
    const data: GeneralInformation = this.state.data!
    const editing = this.state.editing
    if (!editing) {
      return <InfoRow title="ZIP" value={data.Zip} />
    }
    const zipValid = !!data.Zip && ValidZipCode(data.Zip)
    const input = <Form.Control type="text" isInvalid={!zipValid} value={data.Zip} onChange={(e: React.ChangeEvent<HTMLInputElement>) => this.handleZipChange(e)} />
    const result = <InfoRowWithInput title="ZIP" value={data.Zip} className="text-uppercase" input={input} />
    return result

  }

  handleZipChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    this.state.data && this.setState(prevState => {
      return { data: prevState.data ? { ...prevState.data, Zip: value } : prevState.data }
    })
  }

  createWorkPhoneRow = () => {
    const data: GeneralInformation = this.state.data!
    const editing = this.state.editing
    if (!editing) {
      return <InfoRow title="WORK PHONE" value={FormatPhone(data.WPhone || "")} />
    }
    const input = <PhoneNumberMaskedInput isInvalid={!this.isWorkPhoneValid()} value={data.WPhone} onChange={(value: string) => this.handleWorkPhoneChange(value)} />
    const result = <InfoRowWithInput title="WORK PHONE" value={data.WPhone} className="text-uppercase" input={input} />
    return result
  }

  handleWorkPhoneChange = (value: string) => {
    this.state.data && this.setState(prevState => {
      return { data: prevState.data ? { ...prevState.data, WPhone: value } : prevState.data }
    })
  }

  isWorkPhoneValid = () => {
    const data: GeneralInformation = this.state.data!
    const value = data.WPhone ? data.WPhone.trim() : ""
    return this.checkIsPhoneValid(value)
  }
  createMobilePhoneRow = () => {
    const { isGov } = this.props
    const data: GeneralInformation = this.state.data!
    const editing = this.state.editing
    if (!editing) {
      return <InfoRow title="MOBILE PHONE" value={FormatPhone((isGov ? data.CPhone : data.HPhone) || "")} />
    }
    const input = <PhoneNumberMaskedInput isInvalid={!this.isMobilePhoneValid()} value={(isGov ? data.CPhone : data.HPhone) || ""} onChange={(value: string) => this.handleMobilePhoneChange(value)} />
    const result = <InfoRowWithInput title="MOBILE PHONE" value={(isGov ? data.CPhone : data.HPhone) || ""} className="text-uppercase" input={input} />
    return result
  }

  handleMobilePhoneChange = (value: string) => {
    const { isGov } = this.props
    if (isGov) {
      this.state.data && this.setState(prevState => {
        return { data: prevState.data ? { ...prevState.data, CPhone: value } : prevState.data }
      })
    }
    else {
      this.state.data && this.setState(prevState => {
        return { data: prevState.data ? { ...prevState.data, HPhone: value } : prevState.data }
      })
    }
  }

  isMobilePhoneValid = () => {
    const { isGov } = this.props
    const data: GeneralInformation = this.state.data!
    const phone = (isGov ? data.CPhone : data.HPhone) || ""
    const value = phone ? phone.trim() : ""
    return this.checkIsPhoneValid(value)
  }

  createEmailRow = () => {
    const { isGov } = this.props
    const data: GeneralInformation = this.state.data!
    const editing = this.state.editing
    if (!editing) {
      return <InfoRow title="EMAIL" value={data.Email} />
    }
    const input = <Form.Control type="text" isInvalid={!this.isEmailValid()} value={data.Email} onChange={(e: React.ChangeEvent<HTMLInputElement>) => this.handleEmailChange(e)} />
    const result = <InfoRowWithInput title="EMAIL" value={data.Email} className="text-uppercase" input={input} />
    return result
  }

  handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    this.state.data && this.setState(prevState => {
      return { data: prevState.data ? { ...prevState.data, Email: value } : prevState.data }
    })
  }

  isEmailValid = () => {
    const { isGov } = this.props
    const data: GeneralInformation = this.state.data!
    const value = data.Email ? data.Email.trim() : ""
    return this.checkIsEmailValid(value)
  }

  handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
  }

  createInfoRows = () => {
    const { isGov } = this.props
    const data: GeneralInformation = this.state.data!
    let occupationTitle: string = "OCCUPATION"
    if (data.ImplementationAlias?.Occupation) {
      occupationTitle = data.ImplementationAlias.Occupation.toUpperCase()
      if (occupationTitle === "N/A") {
        occupationTitle = "OCCUPATION"
      }
    }
    const firstNameRow = this.createFirstNameRow()
    const lastNameRow = this.createLastNameRow()
    const employerIdRow = this.createEmployerIdRow();
    const driverIdRow = this.createDriverIdRow()
    const ssnRow = this.createSSNRow()
    const alternateIdRow = this.createAlternateIdRow()
    const companyRow = this.createCompanyRow(data.Company)
    const locationRow = this.createLocationRow(data.Location)
    const occupationRow = this.createOccupationRow()
    const regulatoryModeRow = this.createRegulatoryModeRow()
    const superVisorRow = this.createSupervisorRow()
    const hireDateRow = this.createHireDateRow()
    const terminationDateRow = this.createTerminationDateRow()
    const preEmploymentTestOnFileRow = this.createPreEmploymentTestOnFileRow()
    const managerRow = this.createManagerRow()
    const activeRow = this.createInactiveRow()
    const genderRow = this.createGenderRow()
    const dateOfBirthRow = this.createDateOfBirthRow()
    const streeAddressRow = this.createAddress1Row()
    const cityRow = this.createCityRow()
    const stateRow = this.createStateRow()
    const zipRow = this.createZipRow()
    const workPhoneRow = this.createWorkPhoneRow()
    const mobilePhoneRow = this.createMobilePhoneRow()
    const emailRow = this.createEmailRow()
    const result = {
      firstNameRow: firstNameRow,
      lastNameRow: lastNameRow,
      employerIdRow: employerIdRow,
      driverIdRow: driverIdRow,
      ssnRow: ssnRow,
      alternateIdRow: alternateIdRow,
      companyRow: companyRow,
      occupationRow: occupationRow,
      regulatoryModeRow: regulatoryModeRow,
      superVisorRow: superVisorRow,
      hireDateRow: hireDateRow,
      terminationDateRow: terminationDateRow,
      preEmploymentTestOnFileRow: preEmploymentTestOnFileRow,
      managerRow: managerRow,
      activeRow: activeRow,
      genderRow: genderRow,
      dateOfBirthRow: dateOfBirthRow,
      streeAddressRow: streeAddressRow,
      cityRow: cityRow,
      stateRow: stateRow,
      zipRow: zipRow,
      workPhoneRow: workPhoneRow,
      mobilePhoneRow: mobilePhoneRow,
      emailRow: emailRow,
      locationRow: locationRow

    }
    return result
  }

  createUser1Row = () => {
    const data: GeneralInformation = this.state.data!
    const demographicLabels = data.ImplementationAlias
    const demographicInfo = data.PersonDemographicObj
    const editing = this.state.editing
    const title = (demographicLabels.User1Label === "" || demographicLabels.User1Label === "N/A") ? "USER 1" : demographicLabels.User1Label

    if (!editing) {
      return <UserRow title={title} value={demographicInfo.User1} empty="USER 1" />
    }
    if (!this.state.personDemographicObject) {
      return <UserRow title={title} value={demographicInfo.User1} empty="USER 1" />
    }
    const values = this.state.userDefinedRecords.filter(item => item['Type'] === "UR1")
    if (values.length === 0) {
      return <UserRow title={title} value={demographicInfo.User1} empty="USER 1" />
    }
    const code = this.state.personDemographicObject.User1Code
    const value = this.state.personDemographicObject.User1

    const options: KeyValue[] = values.map(item => {
      let rObj: KeyValue = {
        Key: item['Code'],
        Value: item['Description']
      }
      return rObj
    })
    const input = <div className="typeahead">
      <Typeahead id="user1"
        ref={this.user1Typeahead}
        labelKey="Value"
        filterBy={() => true}
        onChange={selected => this.handleUser1Change(selected[0] || { Key: "", Value: "" })}
        options={options}
        selected={code !== "" ? [options.find((el) => el?.Key == code) || options[0]] : []}
        placeholder="Select">
        <Button variant="toggle" onClick={() => { this.user1Typeahead && this.user1Typeahead.current && (this.user1Typeahead.current as any).toggleMenu() }}>
          <FaAngleDown />
        </Button>
      </Typeahead>
    </div>
    const result = <InfoRowWithInput title={title} value={demographicInfo.User1} className="text-uppercase" input={input} />
    return result

  }

  handleUser1Change = (value: KeyValue) => {
    this.state.data && this.state.personDemographicObject && this.setState(prevState => {
      const data = prevState.data
        ? {
          ...prevState.data,
          PersonDemographicObj: prevState.data?.PersonDemographicObj ? { ...prevState.data.PersonDemographicObj, User1: value.Value } : prevState.data?.PersonDemographicObj
        }
        : prevState.data
      return {
        data: data,
        personDemographicObject: prevState.personDemographicObject ? { ...prevState.personDemographicObject, User1Code: value.Key, User1: value.Key } : prevState.personDemographicObject
      };
    })
  }
  isUser1Valid = () => {
    return true
  }

  createUser2Row = () => {
    const data: GeneralInformation = this.state.data!
    const demographicLabels = data.ImplementationAlias
    const demographicInfo = data.PersonDemographicObj
    const editing = this.state.editing
    const title = (demographicLabels.User2Label === "" || demographicLabels.User2Label === "N/A") ? "USER 2" : demographicLabels.User2Label

    if (!editing) {
      return <UserRow title={title} value={demographicInfo.User2} empty="USER 2" />
    }
    if (!this.state.personDemographicObject) {
      return <UserRow title={title} value={demographicInfo.User2} empty="USER 2" />

    }

    const values = this.state.userDefinedRecords.filter(item => item['Type'] === "UR2")
    if (values.length === 0) {
      return <UserRow title={title} value={demographicInfo.User2} empty="USER 2" />
    }
    const code = this.state.personDemographicObject.User2Code
    const value = this.state.personDemographicObject.User2
    const options: KeyValue[] = values.map(item => {
      let rObj: KeyValue = {
        Key: item['Code'],
        Value: item['Description']
      }
      return rObj
    })
    const input = <div className="typeahead">
      <Typeahead id="user2"
        ref={this.user2Typeahead}
        labelKey="Value"
        filterBy={() => true}
        onChange={selected => this.handleUser2Change(selected[0] || { Key: "", Value: "" })}
        options={options}
        selected={code !== "" ? [options.find((el) => el?.Key == code) || options[0]] : []}
        placeholder="Select">
        <Button variant="toggle" onClick={() => { this.user2Typeahead && this.user2Typeahead.current && (this.user2Typeahead.current as any).toggleMenu() }}>
          <FaAngleDown />
        </Button>
      </Typeahead>
    </div>
    const result = <InfoRowWithInput title={title} value={demographicInfo.User2} className="text-uppercase" input={input} />
    return result

  }

  handleUser2Change = (value: KeyValue) => {
    this.state.data && this.state.personDemographicObject && this.setState(prevState => {
      const data = prevState.data
        ? {
          ...prevState.data,
          PersonDemographicObj: prevState.data?.PersonDemographicObj ? { ...prevState.data.PersonDemographicObj, User2: value.Value } : prevState.data?.PersonDemographicObj
        }
        : prevState.data
      return {
        data: data,
        personDemographicObject: prevState.personDemographicObject ? { ...prevState.personDemographicObject, User2Code: value.Key, User2: value.Key } : prevState.personDemographicObject
      };
    })
  }
  isUser2Valid = () => {
    return true
  }
  createUser3Row = () => {
    const data: GeneralInformation = this.state.data!
    const demographicLabels = data.ImplementationAlias
    const demographicInfo = data.PersonDemographicObj
    const editing = this.state.editing
    const title = (demographicLabels.User3Label === "" || demographicLabels.User3Label === "N/A") ? "USER 3" : demographicLabels.User3Label

    if (!editing) {
      return <UserRow title={title} value={demographicInfo.User3} empty="USER 3" />
    }
    if (!this.state.personDemographicObject) {
      return <UserRow title={title} value={demographicInfo.User3} empty="USER 3" />

    }

    const values = this.state.userDefinedRecords.filter(item => item['Type'] === "UR3")
    if (values.length === 0) {
      return <UserRow title={title} value={demographicInfo.User3} empty="USER 3" />
    }
    const code = this.state.personDemographicObject.User3Code
    const value = this.state.personDemographicObject.User3

    const options: KeyValue[] = values.map(item => {
      let rObj: KeyValue = {
        Key: item['Code'],
        Value: item['Description']
      }
      return rObj
    })
    const input = <div className="typeahead">
      <Typeahead id="user3"
        ref={this.user3Typeahead}
        labelKey="Value"
        filterBy={() => true}
        onChange={selected => this.handleUser3Change(selected[0] || { Key: "", Value: "" })}
        options={options}
        selected={code !== "" ? [options.find((el) => el?.Key == code) || options[0]] : []}
        placeholder="Select">
        <Button variant="toggle" onClick={() => { this.user3Typeahead && this.user3Typeahead.current && (this.user3Typeahead.current as any).toggleMenu() }}>
          <FaAngleDown />
        </Button>
      </Typeahead>
    </div>
    const result = <InfoRowWithInput title={title} value={demographicInfo.User3} className="text-uppercase" input={input} />
    return result

  }

  handleUser3Change = (value: KeyValue) => {
    this.state.data && this.state.personDemographicObject && this.setState(prevState => {
      const data = prevState.data
        ? {
          ...prevState.data,
          PersonDemographicObj: prevState.data?.PersonDemographicObj ? { ...prevState.data.PersonDemographicObj, User3: value.Value } : prevState.data?.PersonDemographicObj
        }
        : prevState.data
      return {
        data: data,
        personDemographicObject: prevState.personDemographicObject ? { ...prevState.personDemographicObject, User3Code: value.Key, User3: value.Key } : prevState.personDemographicObject
      };
    })
  }
  isUser3Valid = () => {
    return true
  }

  createUser4Row = () => {
    const data: GeneralInformation = this.state.data!
    const demographicLabels = data.ImplementationAlias
    const demographicInfo = data.PersonDemographicObj
    const editing = this.state.editing
    const title = (demographicLabels.User4Label === "" || demographicLabels.User4Label === "N/A") ? "USER 4" : demographicLabels.User4Label

    if (!editing) {
      return <UserRow title={title} value={demographicInfo.User4} empty="USER 4" />
    }
    if (!this.state.personDemographicObject) {
      return <UserRow title={title} value={demographicInfo.User4} empty="USER 4" />

    }

    const values = this.state.userDefinedRecords.filter(item => item['Type'] === "UR4")
    if (values.length === 0) {
      return <UserRow title={title} value={demographicInfo.User4} empty="USER 4" />
    }
    const code = this.state.personDemographicObject.User4Code
    const value = this.state.personDemographicObject.User4

    const options: KeyValue[] = values.map(item => {
      let rObj: KeyValue = {
        Key: item['Code'],
        Value: item['Description']
      }
      return rObj
    })
    const input = <div className="typeahead">
      <Typeahead id="user4"
        ref={this.user4Typeahead}
        labelKey="Value"
        filterBy={() => true}
        onChange={selected => this.handleUser4Change(selected[0] || { Key: "", Value: "" })}
        options={options}
        selected={code !== "" ? [options.find((el) => el?.Key == code) || options[0]] : []}
        placeholder="Select">
        <Button variant="toggle" onClick={() => { this.user4Typeahead && this.user4Typeahead.current && (this.user4Typeahead.current as any).toggleMenu() }}>
          <FaAngleDown />
        </Button>
      </Typeahead>
    </div>
    const result = <InfoRowWithInput title={title} value={demographicInfo.User4} className="text-uppercase" input={input} />
    return result

  }

  handleUser4Change = (value: KeyValue) => {
    this.state.data && this.state.personDemographicObject && this.setState(prevState => {
      const data = prevState.data
        ? {
          ...prevState.data,
          PersonDemographicObj: prevState.data?.PersonDemographicObj ? { ...prevState.data.PersonDemographicObj, User4: value.Value } : prevState.data?.PersonDemographicObj
        }
        : prevState.data
      return {
        data: data,
        personDemographicObject: prevState.personDemographicObject ? { ...prevState.personDemographicObject, User4Code: value.Key, User4: value.Key } : prevState.personDemographicObject
      };
    })
  }
  isUser4Valid = () => {
    return true
  }
  createUser5Row = () => {
    const data: GeneralInformation = this.state.data!
    const demographicLabels = data.ImplementationAlias
    const demographicInfo = data.PersonDemographicObj
    const editing = this.state.editing
    const title = (demographicLabels.User5Label === "" || demographicLabels.User5Label === "N/A") ? "USER 1" : demographicLabels.User5Label

    if (!editing) {
      return <UserRow title={title} value={demographicInfo.User5} empty="USER 5" />
    }
    if (!this.state.personDemographicObject) {
      return <UserRow title={title} value={demographicInfo.User5} empty="USER 5" />

    }

    const values = this.state.userDefinedRecords.filter(item => item['Type'] === "UR5")
    if (values.length === 0) {
      return <UserRow title={title} value={demographicInfo.User5} empty="USER 5" />
    }
    const code = this.state.personDemographicObject.User5Code
    const value = this.state.personDemographicObject.User5

    const options: KeyValue[] = values.map(item => {
      let rObj: KeyValue = {
        Key: item['Code'],
        Value: item['Description']
      }
      return rObj
    })
    const input = <div className="typeahead">
      <Typeahead id="user5"
        ref={this.user5Typeahead}
        labelKey="Value"
        filterBy={() => true}
        onChange={selected => this.handleUser5Change(selected[0] || { Key: "", Value: "" })}
        options={options}
        selected={code !== "" ? [options.find((el) => el?.Key == code) || options[0]] : []}
        placeholder="Select">
        <Button variant="toggle" onClick={() => { this.user5Typeahead && this.user5Typeahead.current && (this.user5Typeahead.current as any).toggleMenu() }}>
          <FaAngleDown />
        </Button>
      </Typeahead>
    </div>
    const result = <InfoRowWithInput title={title} value={demographicInfo.User5} className="text-uppercase" input={input} />
    return result

  }

  handleUser5Change = (value: KeyValue) => {
    this.state.data && this.state.personDemographicObject && this.setState(prevState => {
      const data = prevState.data
        ? {
          ...prevState.data,
          PersonDemographicObj: prevState.data?.PersonDemographicObj ? { ...prevState.data.PersonDemographicObj, User5: value.Value } : prevState.data?.PersonDemographicObj
        }
        : prevState.data
      return {
        data: data,
        personDemographicObject: prevState.personDemographicObject ? { ...prevState.personDemographicObject, User5Code: value.Key, User5: value.Key } : prevState.personDemographicObject
      };
    })
  }
  isUser5Valid = () => {
    return true
  }
  createUser6Row = () => {
    const data: GeneralInformation = this.state.data!
    const demographicLabels = data.ImplementationAlias
    const demographicInfo = data.PersonDemographicObj
    const editing = this.state.editing
    const title = (demographicLabels.User6Label === "" || demographicLabels.User6Label === "N/A") ? "USER 6" : demographicLabels.User6Label

    if (!editing) {
      return <UserRow title={title} value={demographicInfo.User6} empty="USER 6" />
    }
    if (!this.state.personDemographicObject) {
      return <UserRow title={title} value={demographicInfo.User6} empty="USER 6" />

    }

    const values = this.state.userDefinedRecords.filter(item => item['Type'] === "UR6")
    if (values.length === 0) {
      return <UserRow title={title} value={demographicInfo.User6} empty="USER 6" />
    }
    const code = this.state.personDemographicObject.User6Code
    const value = this.state.personDemographicObject.User6

    const options: KeyValue[] = values.map(item => {
      let rObj: KeyValue = {
        Key: item['Code'],
        Value: item['Description']
      }
      return rObj
    })
    const input = <div className="typeahead">
      <Typeahead id="user6"
        ref={this.user6Typeahead}
        labelKey="Value"
        filterBy={() => true}
        onChange={selected => this.handleUser6Change(selected[0] || { Key: "", Value: "" })}
        options={options}
        selected={code !== "" ? [options.find((el) => el?.Key == code) || options[0]] : []}
        placeholder="Select">
        <Button variant="toggle" onClick={() => { this.user6Typeahead && this.user6Typeahead.current && (this.user6Typeahead.current as any).toggleMenu() }}>
          <FaAngleDown />
        </Button>
      </Typeahead>
    </div>
    const result = <InfoRowWithInput title={title} value={demographicInfo.User6} className="text-uppercase" input={input} />
    return result

  }

  handleUser6Change = (value: KeyValue) => {
    this.state.data && this.state.personDemographicObject && this.setState(prevState => {
      const data = prevState.data
        ? {
          ...prevState.data,
          PersonDemographicObj: prevState.data?.PersonDemographicObj ? { ...prevState.data.PersonDemographicObj, User6: value.Value } : prevState.data?.PersonDemographicObj
        }
        : prevState.data
      return {
        data: data,
        personDemographicObject: prevState.personDemographicObject ? { ...prevState.personDemographicObject, User6Code: value.Key, User6: value.Key } : prevState.personDemographicObject
      };
    })
  }
  isUser6Valid = () => {
    return true
  }
  createUser7Row = () => {
    const data: GeneralInformation = this.state.data!
    const demographicLabels = data.ImplementationAlias
    const demographicInfo = data.PersonDemographicObj
    const editing = this.state.editing
    const title = (demographicLabels.User7Label === "" || demographicLabels.User7Label === "N/A") ? "USER 7" : demographicLabels.User7Label

    if (!editing) {
      return <UserRow title={title} value={demographicInfo.User7} empty="USER 7" />
    }
    if (!this.state.personDemographicObject) {
      return <UserRow title={title} value={demographicInfo.User7} empty="USER 7" />

    }

    const values = this.state.userDefinedRecords.filter(item => item['Type'] === "UR7")
    if (values.length === 0) {
      return <UserRow title={title} value={demographicInfo.User7} empty="USER 7" />
    }
    const code = this.state.personDemographicObject.User7Code
    const value = this.state.personDemographicObject.User7

    const options: KeyValue[] = values.map(item => {
      let rObj: KeyValue = {
        Key: item['Code'],
        Value: item['Description']
      }
      return rObj
    })
    const input = <div className="typeahead">
      <Typeahead id="user7"
        ref={this.user7Typeahead}
        labelKey="Value"
        filterBy={() => true}
        onChange={selected => this.handleUser7Change(selected[0] || { Key: "", Value: "" })}
        options={options}
        selected={code !== "" ? [options.find((el) => el?.Key == code) || options[0]] : []}
        placeholder="Select">
        <Button variant="toggle" onClick={() => { this.user7Typeahead && this.user7Typeahead.current && (this.user7Typeahead.current as any).toggleMenu() }}>
          <FaAngleDown />
        </Button>
      </Typeahead>
    </div>
    const result = <InfoRowWithInput title={title} value={demographicInfo.User7} className="text-uppercase" input={input} />
    return result

  }

  handleUser7Change = (value: KeyValue) => {
    this.state.data && this.state.personDemographicObject && this.setState(prevState => {
      const data = prevState.data
        ? {
          ...prevState.data,
          PersonDemographicObj: prevState.data?.PersonDemographicObj ? { ...prevState.data.PersonDemographicObj, User7: value.Value } : prevState.data?.PersonDemographicObj
        }
        : prevState.data
      return {
        data: data,
        personDemographicObject: prevState.personDemographicObject ? { ...prevState.personDemographicObject, User7Code: value.Key, User7: value.Key } : prevState.personDemographicObject
      };
    })
  }
  isUser7Valid = () => {
    return true
  }

  createUser8Row = () => {
    const data: GeneralInformation = this.state.data!
    const demographicLabels = data.ImplementationAlias
    const demographicInfo = data.PersonDemographicObj
    const editing = this.state.editing
    const title = (demographicLabels.User8Label === "" || demographicLabels.User8Label === "N/A") ? "USER 8" : demographicLabels.User8Label

    if (!editing) {
      return <UserRow title={title} value={demographicInfo.User8} empty="USER 8" />
    }
    if (!this.state.personDemographicObject) {
      return <UserRow title={title} value={demographicInfo.User8} empty="USER 8" />

    }

    const values = this.state.userDefinedRecords.filter(item => item['Type'] === "UR8")
    if (values.length === 0) {
      return <UserRow title={title} value={demographicInfo.User8} empty="USER 8" />
    }
    const code = this.state.personDemographicObject.User8Code
    const value = this.state.personDemographicObject.User8

    const options: KeyValue[] = values.map(item => {
      let rObj: KeyValue = {
        Key: item['Code'],
        Value: item['Description']
      }
      return rObj
    })
    const input = <div className="typeahead">
      <Typeahead id="user8"
        ref={this.user8Typeahead}
        labelKey="Value"
        filterBy={() => true}
        onChange={selected => this.handleUser8Change(selected[0] || { Key: "", Value: "" })}
        options={options}
        selected={code !== "" ? [options.find((el) => el?.Key == code) || options[0]] : []}
        placeholder="Select">
        <Button variant="toggle" onClick={() => { this.user8Typeahead && this.user8Typeahead.current && (this.user8Typeahead.current as any).toggleMenu() }}>
          <FaAngleDown />
        </Button>
      </Typeahead>
    </div>
    const result = <InfoRowWithInput title={title} value={demographicInfo.User8} className="text-uppercase" input={input} />
    return result

  }

  handleUser8Change = (value: KeyValue) => {
    this.state.data && this.state.personDemographicObject && this.setState(prevState => {
      const data = prevState.data
        ? {
          ...prevState.data,
          PersonDemographicObj: prevState.data?.PersonDemographicObj ? { ...prevState.data.PersonDemographicObj, User8: value.Value } : prevState.data?.PersonDemographicObj
        }
        : prevState.data
      return {
        data: data,
        personDemographicObject: prevState.personDemographicObject ? { ...prevState.personDemographicObject, User8Code: value.Key, User8: value.Key } : prevState.personDemographicObject
      };
    })
  }
  isUser8Valid = () => {
    return true
  }

  createUser9TextRow = () => {
    const data: GeneralInformation = this.state.data!
    const demographicLabels = data.ImplementationAlias
    const demographicInfo = data.PersonDemographicObj
    const editing = this.state.editing
    const title = (demographicLabels.User9Label === "" || demographicLabels.User9Label === "N/A") ? "USER 9" : demographicLabels.User9Label

    if (!editing) {
      return <UserRow title={title} value={demographicInfo.User9} empty="USER 9" />
    }

    const input = <Form.Control type="text" isInvalid={!this.isUser9TextValid()} value={demographicInfo.User9 || ""} onChange={(e: React.ChangeEvent<HTMLInputElement>) => this.handleUser9TextChange(e)} />
    const result = <InfoRowWithInput title={title} value={demographicInfo.User9} className="text-uppercase" input={input} />
    return result
  }

  handleUser9TextChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value
    this.state.data && this.state.personDemographicObject && this.setState(prevState => {
      const data = prevState.data
        ? {
          ...prevState.data,
          PersonDemographicObj: prevState.data?.PersonDemographicObj ? { ...prevState.data.PersonDemographicObj, User9: value } : prevState.data?.PersonDemographicObj
        }
        : prevState.data
      return {
        data: data,
        personDemographicObject: prevState.personDemographicObject ? { ...prevState.personDemographicObject, User9: value } : prevState.personDemographicObject
      };
    })
  }

  isUser9TextValid = () => {
    return true
  }

  createUser10TextRow = () => {
    const data: GeneralInformation = this.state.data!
    const demographicLabels = data.ImplementationAlias
    const demographicInfo = data.PersonDemographicObj
    const editing = this.state.editing
    const title = (demographicLabels.User10Label === "" || demographicLabels.User10Label === "N/A") ? "USER 10" : demographicLabels.User10Label

    if (!editing) {
      return <UserRow title={title} value={demographicInfo.User10} empty="USER 10" />
    }
    const input = <Form.Control type="text" isInvalid={!this.isUser10TextValid()} value={demographicInfo.User10 || ""} onChange={(e: React.ChangeEvent<HTMLInputElement>) => this.handleUser10TextChange(e)} />
    const result = <InfoRowWithInput title={title} value={demographicInfo.User10} className="text-uppercase" input={input} />
    return result
  }

  handleUser10TextChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value
    this.state.data && this.state.personDemographicObject && this.setState(prevState => {
      const data = prevState.data
        ? {
          ...prevState.data,
          PersonDemographicObj: prevState.data?.PersonDemographicObj ? { ...prevState.data.PersonDemographicObj, User10: value } : prevState.data?.PersonDemographicObj
        }
        : prevState.data
      return {
        data: data,
        personDemographicObject: prevState.personDemographicObject ? { ...prevState.personDemographicObject, User10: value } : prevState.personDemographicObject
      };
    })
  }

  isUser10TextValid = () => {
    return true
  }

  isCompanyValid = () =>{
    return this.state.isCompaniesLoading || !!this.state.selectedCompany
  }

  isValid = () => {
    const { editing } = this.state
    return editing && this.isSSNValid() &&  this.isCompanyValid()
  }
  createUserRows = () => {
    const data: GeneralInformation = this.state.data!
    const demographicLabels = data.ImplementationAlias
    const demographicInfo = data.PersonDemographicObj
    const userRow1 = this.createUser1Row()
    const userRow2 = this.createUser2Row()
    const userRow3 = this.createUser3Row()
    const userRow4 = this.createUser4Row()
    const userRow5 = this.createUser5Row()
    const userRow6 = this.createUser6Row()
    const userRow7 = this.createUser7Row()
    const userRow8 = this.createUser8Row()
    const userRow9 = this.createUser9TextRow()
    const userRow10 = this.createUser10TextRow()
    const result = {
      userRow1: userRow1,
      userRow2: userRow2,
      userRow3: userRow3,
      userRow4: userRow4,
      userRow5: userRow5,
      userRow6: userRow6,
      userRow7: userRow7,
      userRow8: userRow8,
      userRow9: userRow9,
      userRow10: userRow10

    }
    return result
  }

  render() {
    const { isGov } = this.props
    if (!this.state.data) {
      return this.state.isGeneralInfoLoading ? <Spinner animation="border" size="sm" /> : <></>
    }
    const companyAdminOfAnotherCompany = this.props.isCompanyAdmin && this.props.companyID !== this.state.data.CompanyID
    const canEdit = !companyAdminOfAnotherCompany && (this.props.userPermissions?.canEditPersonnel || this.props.userPermissions?.CanManageConsortiumPools ? true : false)
    const editing = this.state.editing

    const infoRows = this.createInfoRows();
    const userRows = this.createUserRows();


    return (
      <Container className="general-info px-4 pb-4 pt-3">
        <EmployeeRegModeModal show={this.state.showEmployeeRegModes}
          selectedRegulatoryModes={this.state.data.RegModCatList}
          accountType=""
          onClose={() => this.handleRegulatoryModeClose()}
          onSave={(items: RegMode[]) => this.handleRegulatoryModeSave(items)} />
        {this.state.showSupervisors && <SupervisorsModal
          Supervisor1={this.state.data.Supervisor1Data}
          Supervisor2={this.state.data.Supervisor2Data}
          onClose={() => this.handleSupervisorsClose()}
          onSave={(items: Supervisor[]) => this.handleSupervisorsSave(items)} />}
        <Row>
          <Col xs={12} lg={6}>
            <HeaderRow title="EMPLOYMENT INFO" />
            {infoRows.firstNameRow}
            {infoRows.lastNameRow}
            {infoRows.employerIdRow}
            {!isGov && <React.Fragment>
              {infoRows.driverIdRow}
              {infoRows.ssnRow}
              {infoRows.alternateIdRow}
            </React.Fragment>}
            {isGov && infoRows.companyRow}
            {!isGov && <React.Fragment>
              {infoRows.occupationRow}
              {infoRows.regulatoryModeRow}
              {infoRows.superVisorRow}
              {infoRows.hireDateRow}
              {infoRows.terminationDateRow}
              {infoRows.preEmploymentTestOnFileRow}
              {infoRows.managerRow}
            </React.Fragment>}
            {infoRows.activeRow}
            <HeaderRow title="GENERAL" />
            {infoRows.genderRow}
            {infoRows.dateOfBirthRow}
            <HeaderRow title="CONTACT INFO" />
            {infoRows.streeAddressRow}
            {infoRows.cityRow}
            {infoRows.stateRow}
            {infoRows.zipRow}
            {infoRows.workPhoneRow}
            {infoRows.mobilePhoneRow}
            {infoRows.emailRow}
          </Col>
          {!isGov && <React.Fragment>
            <Col xs={12} lg={6}>
              <HeaderRowWithSwitchMode title="DEMOGRAPHICS" showEditButton={canEdit} editing={editing} handleToggleEditMode={this.handleToggleEditMode} />
              {infoRows.companyRow}
              {infoRows.locationRow}
              {userRows.userRow1}
              {userRows.userRow2}
              {userRows.userRow3}
              {userRows.userRow4}
              {userRows.userRow5}
              {userRows.userRow6}
              {userRows.userRow7}
              {userRows.userRow8}
              {userRows.userRow9}
              {userRows.userRow10}
            </Col>
          </React.Fragment>}
        </Row>
        <Row className="buttons-block" hidden={!this.state.editing}>
          <Button variant="secondary" onClick={this.handleToggleEditMode}>CANCEL</Button>
          <ActionButton variant="primary" onClick={this.handleSubmit} spin={this.state.saving} disabled={!this.isValid()} disableOnSpin>SAVE</ActionButton>
        </Row>

      </Container>
    )
  }

}

function mapStateToProps(state: AppState): GeneralInfoAuthProps {
  const userAccess = BuildUserAccess(state)
  const selectedCompany = GetSelectedAssignedClinic(state)
  return {
    userPermissions: userAccess,
    isPortalAdmin: isPortalAdmin(state),
    isCompanyAdmin: isCompanyAdmin(state),
    companyID: selectedCompany?.AccountID || 0,
  }
}
const ConnectedGeneralInfo = connect(mapStateToProps)(GeneralInfo)
export default ConnectedGeneralInfo
